/*
 * File: AsanaHome.tsx
 * Project: a-a
 * File Created: Tuesday, 22nd April 2025 1:50:49 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 21st July 2025 11:59:34 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import zeplinColor from '../../../../theme/Color';
import AsanaOverviewCard from '../AsanaOverviewCard./AsanaOverviewCard';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Gauge, gaugeClasses, GaugeContainer } from '@mui/x-charts/Gauge';
import { PieChart } from '@mui/x-charts/PieChart';

import AsanaLayout from '../AsanaLayout/AsanaLayout';
import { AsanaService } from '../../../../service/asana.service';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import CircleIcon from '@mui/icons-material/Circle';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import { useLocation } from 'react-router-dom';

//trigger deployment ....

ChartJS.register(ArcElement, Tooltip, Legend);

const AsanaHome = () => {
  const location = useLocation();
  const asanaToken = localStorage.getItem('asana-token') || '';
  const [team, setTeam] = useState<any[]>();
  const [loadingTeam, setLoadingTeam] = useState(false);
  const [loadingProject, setLoadingProject] = useState(false);
  const [nextStart, setNextStart] = useState<{ nextStart: number; offset: string | null }>({
    nextStart: 0,
    offset: '',
  });
  const [loadingStats, setLoadingStats] = useState(false);
  const [error, setError] = useState(false);
  const [copy, setCopy] = useState('');
  const [projects, setProjects] = useState<any[]>();
  const [stats, setStats] = useState({
    done: 0,
    donePercentage: 0,
    due: 0,
    inProgress: 0,
    overdue: 0,
    toDo: 0,
    totalProjects: 0,
    totalTasks: 0,
  });

  const getStats = async () => {
    try {
      setLoadingStats(true);
      const res = await AsanaService.getAsanaStats();
      console.log(res);
      setStats(res);
    } catch (err) {
      setError(true);
    } finally {
      setLoadingStats(false);
    }
  };
  const getTeams = async () => {
    try {
      setLoadingTeam(true);
      const res = await AsanaService.getAsanaTeams();
      console.log(res);
      setTeam(res);
    } catch (err) {
      setError(true);
    } finally {
      setLoadingTeam(false);
    }
  };
  const getProjects = async (query?: any, next?: boolean, add?: boolean) => {
    try {
      setLoadingProject(true);
      const res = await AsanaService.getAsanaProject({
        ...query,
        limit: 12,
        ...(next && { offset: nextStart?.offset }),
      });

      setNextStart(
        (prev) =>
          ({
            nextStart: res?.nextOffset ? prev?.nextStart + 12 : prev.nextStart,
            offset: res?.nextOffset ?? null,
          } as { nextStart: number; offset: string | null }),
      );
      setProjects((prev) =>
        prev?.length && !add ? [...prev, ...res?.projects] : [...res?.projects],
      );
    } catch (err) {
      setError(true);
    } finally {
      setLoadingProject(false);
    }
  };

  const handleClose = () => {
    setError(false);
    setCopy('');
  };
  const alertMessage = (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // backgroundColor: !error ? zeplinColor.Success : '',
          borderRadius: '60px',
          padding: '3px',
        }}
      >
        <img src='/assets/checkmark-green.png' width={24} height={24} />
      </div>
      <Typography variant='body2' style={{ color: zeplinColor.Neutral1 }}>
        {copy}
      </Typography>
    </div>
  );

  useEffect(() => {
    // getStats();
    if (asanaToken) {
      getTeams();
      getProjects();
      getStats();
    }
  }, [asanaToken]);

  return (
    <>
      {/* <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} /> */}
      <Box sx={{ padding: '24px 24px 0px 24px' }}>
        <Box sx={{ display: 'flex', gap: '16px' }}>
          <AsanaOverviewCard
            data={stats?.totalProjects || 0}
            title={'Total Projects'}
            icon={'/assets/total-projects.png'}
            backgroundColor={zeplinColor.Blue1}
          />
          <AsanaOverviewCard
            data={stats?.totalTasks || 0}
            title={'Total Tasks'}
            icon={'/assets/total-tasks.png'}
            backgroundColor={zeplinColor.Yellow}
          />
          <CustomCard
            styles={{
              borderRadius: '16px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral3,
              // width: '195.5px',
              height: '195px',
              display: 'flex',
              flexDirection: 'column',
              //   justifyContent: 'center',
              //   alignItems: 'center',
              flex: 3,
              gap: '10px',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
              <Typography variant='body3'>Tasks Overview </Typography>
              <Typography variant='display4'>{stats?.donePercentage}%</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '4px' }}>
              {/* <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  flex: Math.ceil(
                    (stats?.toDo / (stats?.toDo + stats?.inProgress + stats?.done)) * 100,
                  ),
                }}
              >
                <Typography variant='body2'>{stats?.toDo}</Typography>
                <LightTooltip
                  title={
                    <Box
                      sx={{
                        display: 'flex',
                        // flexDirection: 'column',
                        gap: '24px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          // flexDirection: 'column',
                          gap: '8px',
                          // justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <CircleIcon sx={{ fontSize: '12px', color: zeplinColor.Yellow1 }} />
                        <Typography variant='body3' color={zeplinColor.BasicBlack}>
                          To Do
                        </Typography>
                      </Box>
                      <Typography variant='body1' color={zeplinColor.BasicBlack}>
                        {stats?.toDo} Tasks
                      </Typography>
                    </Box>
                  }
                  placement='top'
                  style={{
                    backgroundColor: zeplinColor.Neutral1,
                    borderRadius: '14px',
                    padding: '16px',
                    // width: '184px',
                    // zIndex: 9999,
                  }}
                >
                  <Box
                    sx={{
                      height: '48px',
                      borderRadius: '12px',
                      width: '100%',
                      backgroundColor: zeplinColor.Yellow1,
                    }}
                  ></Box>
                </LightTooltip>
              </Box> */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  flex: Math.ceil(
                    (stats?.inProgress / (stats?.toDo + stats?.inProgress + stats?.done)) * 100,
                  ),
                }}
              >
                <Typography variant='body2'>{stats?.inProgress}</Typography>
                <LightTooltip
                  title={
                    <Box
                      sx={{
                        display: 'flex',
                        // flexDirection: 'column',
                        gap: '24px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          // flexDirection: 'column',
                          alignItems: 'center',

                          gap: '8px',
                          // justifyContent: 'space-between',
                        }}
                      >
                        <CircleIcon sx={{ fontSize: '12px', color: zeplinColor.Blue4 }} />
                        <Typography variant='body3' color={zeplinColor.Neutral1}>
                          Incomplete
                        </Typography>
                      </Box>
                      <Typography variant='body1' color={zeplinColor.Neutral1}>
                        {stats?.inProgress} Tasks
                      </Typography>
                    </Box>
                  }
                  placement='top'
                  style={{
                    backgroundColor: zeplinColor.BasicBlack,
                    borderRadius: '14px',
                    padding: '16px',
                    // width: '184px',
                    // zIndex: 9999,
                  }}
                >
                  <Box
                    sx={{
                      height: '48px',
                      borderRadius: '12px',
                      width: '100%',
                      backgroundColor: zeplinColor.Blue4,
                    }}
                  ></Box>
                </LightTooltip>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  flex: Math.ceil(
                    (stats?.done / (stats?.toDo + stats?.inProgress + stats?.done)) * 100,
                  ),
                }}
              >
                <Typography variant='body2'>{stats?.done}</Typography>
                <LightTooltip
                  title={
                    <Box
                      sx={{
                        display: 'flex',
                        // flexDirection: 'column',
                        gap: '24px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          // flexDirection: 'column',
                          alignItems: 'center',
                          gap: '8px',
                          // justifyContent: 'space-between',
                        }}
                      >
                        <CircleIcon sx={{ fontSize: '12px', color: zeplinColor.Green3 }} />
                        <Typography variant='body3' color={zeplinColor.Neutral1}>
                          Complete
                        </Typography>
                      </Box>
                      <Typography variant='body1' color={zeplinColor.Neutral1}>
                        {stats?.done} Tasks
                      </Typography>
                    </Box>
                  }
                  placement='top'
                  style={{
                    backgroundColor: zeplinColor.BasicBlack,
                    borderRadius: '14px',
                    padding: '16px',
                    // width: '184px',
                    // zIndex: 9999,
                  }}
                >
                  <Box
                    sx={{
                      height: '48px',
                      borderRadius: '12px',
                      width: '100%',
                      backgroundColor: zeplinColor.Green3,
                    }}
                  ></Box>
                </LightTooltip>
              </Box>
            </Box>
          </CustomCard>
          <CustomCard
            styles={{
              borderRadius: '16px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral3,
              // width: '195.5px',
              height: '195px',
              display: 'flex',
              flexDirection: 'column',
              //   justifyContent: 'center',
              //   alignItems: 'center',
              flex: 3,
              gap: '10px',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
              <Typography variant='body3'>Due vs Overdue Tasks </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* <Doughnut
                //   options={...}
                data={data}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                }}
                //   {...props}
              /> */}
              {/* <Box>chart</Box> */}
              {/* <Gauge
                cornerRadius='2px'
                value={+((20 / 120) * 100).toFixed(0)}
                startAngle={5}
                innerRadius={32}
                sx={(theme) => ({
                  [`& .${gaugeClasses.valueText}`]: {
                    fontSize: '28px',
                    fontWeight: 700,
                  },
                  [`& .${gaugeClasses.valueArc}`]: {
                    fill: zeplinColor.Blue4,
                    gap: '2px',
                  },
                  [`& .${gaugeClasses.referenceArc}`]: {
                    fill: zeplinColor.Red1,
                  },
                  width: '106px',
                  height: '106px',
                })}
              /> */}
              <Box sx={{ flex: 1, position: 'relative' }}>
                <PieChart
                  sx={{ flex: 1, height: '110px', position: 'relative' }}
                  hideLegend={true}
                  series={[
                    {
                      data: [
                        { id: 0, value: stats?.due, label: 'due', color: zeplinColor.Blue4 },
                        { id: 1, value: stats?.overdue, label: 'overdue', color: zeplinColor.Red1 },
                      ],
                      innerRadius: 35,
                      // outerRadius: 100,
                      paddingAngle: 2,
                      cornerRadius: 3,

                      // startAngle: 0,
                      // endAngle: 0,

                      cx: 80,
                      // cy: 150,
                    },
                  ]}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '5.3rem',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    fontSize: '1rem', // Adjust as needed
                    fontWeight: 'bold', // Adjust as needed
                    color: 'rgba(0, 0, 0, 0.87)',
                  }}
                >
                  {stats?.due + stats?.overdue}
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <img src={'/assets/due-logo.png'} width={'20px'} height={'20px'} />
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '24px',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flex: 1,
                    }}
                  >
                    <Typography variant='body3'>Due</Typography>
                    <Typography variant='heading4'>{stats?.due}</Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center',
                    // justifyContent: 'space-between',
                  }}
                >
                  <img src={'/assets/overdue-icon.svg'} width={'20px'} height={'20px'} />
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '24px',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flex: 1,
                    }}
                  >
                    <Typography variant='body3'>Overdue</Typography>
                    <Typography variant='heading4'>{stats?.overdue}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Box>
        <AsanaLayout
          team={team}
          projects={projects}
          getProjects={getProjects}
          nextStart={nextStart}
          getStats={getStats}
          loadingProject={loadingProject}
          loadingTeam={loadingTeam}
          setCopy={setCopy}
          setProjects={setProjects}
        />
        <CustomAlert
          open={error || copy ? true : false}
          handleClose={handleClose}
          message={
            error ? (
              <CustomAlertContain
                alert={error && 'Something went wrong'}
                alertIcon={error && <img src='/assets/error.svg' width={24} height={24} />}
                error={error ? true : false}
              />
            ) : copy ? (
              alertMessage
            ) : (
              ''
            )
          }
          error={error ? true : false}
        />
      </Box>
    </>
  );
};

export default AsanaHome;
